import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import PopularShows from './components/PopularShows';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91美剧网 - 最新美剧在线观看与追剧平台',
    description: '91美剧网是专注美剧资源的在线追剧平台，提供最新热门美剧、经典美剧全集免费在线观看，涵盖动作、悬疑、科幻、爱情等多种类型。',
    url: 'https://www.91meiju.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '91美剧网',
      url: 'https://www.91meiju.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <CategoryNav />
          <PopularShows />
          <LatestUpdates />
        </main>
        <Footer />
      </div>
    </>
  );
}